import React, {Component} from 'react';
import {connect} from 'react-redux';

import "./ZoneNearBy.css";
import {MAP_STYLE_JSON, ZoneNearbyDataType} from "../../../../Enums";
import {MoneyFormat} from "../../../../../../utils/NumberUtil";


//调大比例尺，可以看到全局，同时配合园区位置居中显示
let defaultZoom = 10;
//最大放大比例尺
let maxZoom = 13;
let rentalItemMap;

//园区位置
class ZoneNearBy extends Component {

    constructor(props) {
        super(props);
        this.state = {
            tagList: [
                {name: "收费站", value: "收费站"},
                {name: "火车站", value: "火车站"},
                {name: "机场", value: "机场"},
                {name: "港口", value: "港口"}
            ],
            showTag: "收费站",
            initFlag: true,
            dataList: [],
            showSearchResult: false,
            duration: "",
            distance: "",
            searchValue: ""
        }
    }


    componentDidMount() {
        // 创建Map实例,设置地图允许的最小/大级别
        rentalItemMap = new window.BMap.Map("nearbyMap", {minZoom: defaultZoom, maxZoom: maxZoom});
        const top_left_navigation = new window.BMap.NavigationControl({
            anchor: window.BMAP_ANCHOR_TOP_LEFT,
            type: window.BMAP_NAVIGATION_CONTROL_ZOOM
        });
        rentalItemMap.enableScrollWheelZoom()//左上角，缩放按钮
        if (rentalItemMap) {
            // rentalItemMap.addControl(top_left_navigation);
        }
        //初始化上海市中心

        rentalItemMap.centerAndZoom(new window.BMap.Point(121.50, 31.33), defaultZoom);  // 初始化地图,设置中心点坐标和地图级别
        rentalItemMap.setMapStyleV2({styleJson: MAP_STYLE_JSON});
        this.forceUpdate();//地图有时加载比后台数据获取慢，因此直接调用进行重绘

        // this._handleSearchNearRentalZones(5, new window.BMap.Point(121.50, 31.33));//附近五公里
    }

    onTabChange = (key, type) => {

        this.setState({[type]: key});
    };


    renderItemList(itemList) {

        return itemList.map((item, index) => {
            return <span
                key={index}>{index > 0 ? "、" : ""} {item.name}(约{MoneyFormat.formatOne(item.distance / 1000)}公里)</span>
        });
    }

    // _handleClearAddr(value) {
    //     let addr = document.getElementById('addr');
    //     addr.value = '';
    //     this.setState({condition: ''})
    //     this.setState({searched: false})
    //     //传出区域范围清空事件
    //     this.props.onClearKey && this.props.onClearKey.call(this);
    //     //关闭下拉地址选项框
    //     this.props.dispatch(refreshZoneMapSearchConditionList(null, false));
    // }

    // _handleSearch(value, bmap) {
    //
    //     let valueInfo = value && value.target ? value.target.value : value;
    //     this.setState({searchValue: valueInfo})
    //
    //     if (!valueInfo) {
    //         this.state.duration = "";
    //         return;
    //     }
    //
    //     const self = this;
    //     const options = {
    //         onSearchComplete: function (results) {
    //             if (local.getStatus() === window.BMAP_STATUS_SUCCESS) {
    //                 // 判断状态是否正确
    //                 const resultItemList = [];
    //                 for (let i = 0; i < results.getCurrentNumPois(); i++) {
    //                     const item = results.getPoi(i);
    //                     const point = new window.BMap.Point(item.point.lng, item.point.lat);
    //                     // const marker = new window.BMap.Marker(point);
    //                     item.point = point;
    //                     // item.marker = marker;
    //                     //查询后，默认设置第一个为中心点
    //
    //                     resultItemList.push(item);
    //                 }
    //
    //                 self.setState({dataList: resultItemList, showSearchResult: true})
    //             }
    //         }
    //     };
    //     const local = new window.BMap.LocalSearch(bmap, options);
    //     local.search(valueInfo);
    // }
    //
    // /**
    //  * 目标位置输入框
    //  * @private
    //  */
    // _renderInput() {
    //     return (
    //         <div>
    //             <span style={{marginLeft: "10px", marginRight: "10px"}}>目标位置</span>
    //             <Input.TextArea
    //                 allowClear autoSize={{maxRow: 2, minRow: 2}}
    //                 style={{width: "250px", border: "none", borderBottom: "1px solid #000000"}}
    //                 // defaultValue={this.props.zoneCreateSearchAndPoint.search ? this.props.zoneCreateSearchAndPoint.search : ""}
    //                 value={this.state.searchValue}
    //                 // size="small"
    //                 placeholder="可输入具体地址 &#10;了解该房源到该地址的行驶距离"
    //                 onChange={(value) => this._handleSearch(value, rentalItemMap)}
    //             />
    //             {
    //                 this.state.distance !== "" && this.state.duration !== "" ?
    //                     <p style={{
    //                         marginLeft: "75px",
    //                         marginTop: "5px"
    //                     }}>驾车 {this.state.duration} ｜ {this.state.distance} </p>
    //                     : null
    //             }
    //         </div>
    //     );
    // }

    render() {
        const zone = Object.assign({}, this.props.zone);

        let point = null;
        const zoneIconUrl = require("../../../../../../images/bmap/仓库.svg");
        const billStationIconUrl = require("../../../../../../images/bmap/收费站.svg");
        const trainStationIconUrl = require("../../../../../../images/bmap/火车站.svg");
        const airportIconUrl = require("../../../../../../images/bmap/机场.svg");
        const portIconUrl = require("../../../../../../images/bmap/港口.svg");
        const billStationList = [];
        const trainStationList = [];
        const airportList = [];
        const portList = [];
        // 确保数据有了以后，再进行查询
        if (rentalItemMap && zone.longitude && zone.latitude) {

            rentalItemMap.clearOverlays();
            point = new window.BMap.Point(zone.longitude, zone.latitude);

            let zoneIcon = new window.BMap.Icon(zoneIconUrl,
                new window.BMap.Size(32, 32), {
                    imageSize: new window.BMap.Size(32, 32),
                    offset: new window.BMap.Size(10, 24),
                });
            let zoneMarker = new window.BMap.Marker(point, {icon: zoneIcon});

            rentalItemMap.addOverlay(zoneMarker);

            rentalItemMap.centerAndZoom(point, defaultZoom);
            //
            // let nearbyDataObject = zone.nearbyData ? JSON.parse(zone.nearbyData) : {};
            // let itemsList = nearbyDataObject.itemList ? nearbyDataObject.itemList : [];
            let itemsList = zone.showNearbyList ? zone.showNearbyList : [];
            itemsList.forEach(item => {
                point = new window.BMap.Point(item.lng, item.lat);
                let iconUrl = billStationIconUrl;
                if (item.type === ZoneNearbyDataType.Enum.Airport) {
                    iconUrl = airportIconUrl;
                    airportList.push(item);
                } else if (item.type === ZoneNearbyDataType.Enum.TrainStation) {
                    iconUrl = trainStationIconUrl;
                    trainStationList.push(item);

                } else if (item.type === ZoneNearbyDataType.Enum.Port) {
                    iconUrl = portIconUrl;
                    portList.push(item);
                } else {
                    billStationList.push(item)
                }

                let zoneIcon = new window.BMap.Icon(iconUrl,
                    new window.BMap.Size(24, 24), {
                        imageSize: new window.BMap.Size(24, 24),
                        offset: new window.BMap.Size(10, 24),
                    });

                let zoneMarker = new window.BMap.Marker(point, {icon: zoneIcon});

                rentalItemMap.addOverlay(zoneMarker);
            })
        }
        let dataList = this.state.dataList;
        if (dataList.length > 5) {
            dataList = dataList.slice(0, 5);
        }
        return (
            <div className="nearby-box">
                <div className="nearby-map-box">
                    <div id="nearbyMap" className="nearby-map"></div>

                </div>


                <div className='nearby-info-box'>
                    {/*<div className='nearby-data-panel'>*/}
                        {this._renderNearbyInfoItem(billStationList, billStationIconUrl, '收费站')}
                        {this._renderNearbyInfoItem(airportList, airportIconUrl, '机场')}
                        {this._renderNearbyInfoItem(trainStationList, trainStationIconUrl, '火车站')}
                        {this._renderNearbyInfoItem(portList, portIconUrl, '港口')}

                    {/*</div>*/}
                </div>
            </div>
        );
    }

    _renderNearbyInfoItem(list, iconUrl, label) {
        return list.length > 0 ?
            <div className="nearby-data-row">
            <div className="nearby-data-icon"><img src={iconUrl}
                                                   /></div>
            <div className="nearby-data-label">{label}</div>
            <div className="nearby-data-content"> {this.renderItemList(list)}</div>

        </div> : null;
    }
}

function mapStateToProps(store) {
    return {}
}

export default connect(mapStateToProps)(ZoneNearBy);
